// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep.cdk-overlay-pane {
  max-width: 60% !important;
  pointer-events: auto;
  width: 100%;
  position: static;
  position: absolute !important;
  margin-left: 0px;
  margin-right: 0px;
  right: 3% !important;
  transform: none !important;
}

::ng-deep.mat-dialog-title {
  margin: 0 !important;
  padding: 1% !important;
  background-color: #17a2b8 !important;
  color: white !important;
  padding-block: 0px !important;
  font-size: 15px !important;
}

::ng-deep .mat-dialog-content {
  overflow-x: hidden !important;
  max-height: 440px !important;
  padding-inline: 5% !important;
  padding-block: 1% !important;
}

::ng-deep.mat-dialog-container {
  transform: none !important;
  padding: 0 !important;
  overflow-x: hidden !important;
}

::ng-deep .mat-dialog-actions {
  border-top: 1px solid rgba(207, 185, 185, 0.4588235294) !important;
  background-color: lightblue !important;
  padding: 0 !important;
  justify-content: end !important;
  margin-bottom: 0 !important;
  min-height: 41px;
  overflow: hidden;
}

.close_btn {
  margin-left: 48px;
  height: 29px;
  position: relative;
  top: -3px;
}

.update_btn {
  position: relative;
  top: -3px;
  height: 29px;
}

::ng-deep.mat-select-panel-wrap {
  flex-basis: unset !important;
}

.save_btn_condition {
  width: -moz-fit-content;
  width: fit-content;
  position: relative;
  left: 91%;
  margin-bottom: 1%;
}

.Version_dropDownss {
  margin-left: 4%;
  margin-bottom: 4%;
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
  width: 80%;
}

::ng-deep.Version_dropDownss .mat-form-field-infix {
  border: 0 !important;
  height: 30px !important;
  font-size: 13px;
}

::ng-deep.Version_dropDownss .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Version_dropDownss .mat-form-field-label-wrapper {
  top: -1px !important;
}

.mat_selection {
  margin-left: 4%;
  margin-bottom: 4%;
  height: 35px;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
}

::ng-deep.mat_selection .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.mat-selection_label .mat-form-field-label-wrapper {
  position: absolute !important;
  top: 1px !important;
}

::ng-deep.mat-selection_label .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

.inputfield {
  height: 28px;
  font-size: 12px;
  border-radius: 5px;
  border: 1px solid grey;
}`, "",{"version":3,"sources":["webpack://./src/app/condition/condition.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACE,oBAAA;EACA,WAAA;EACA,gBAAA;EAEA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACJ,0BAAA;AAAA;;AAGA;EACE,oBAAA;EACE,sBAAA;EACA,oCAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;AAAJ;;AAGA;EACE,6BAAA;EACA,4BAAA;EAEA,6BAAA;EACA,4BAAA;AADF;;AAIA;EACE,0BAAA;EACA,qBAAA;EACA,6BAAA;AADF;;AAIA;EACE,kEAAA;EACA,sCAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;EAAkB,YAAA;EAAa,kBAAA;EAAmB,SAAA;AAEpD;;AAAA;EACE,kBAAA;EACE,SAAA;EACA,YAAA;AAGJ;;AAIA;EACE,4BAAA;AADF;;AAIA;EACI,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AADJ;;AAKA;EAEE,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAJF;;AAMA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAHF;;AAKA;EACE,WAAA;EACA,UAAA;AAFF;;AAIA;EACE,oBAAA;AADF;;AAGA;EAEE,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAFF;;AAIA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAGA;EACE,WAAA;EACA,UAAA;AAAF;;AAEA;EACE,6BAAA;EACA,mBAAA;AACF;;AACA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAEF;;AAAA;EACE,WAAA;EACA,UAAA;AAGF;;AAAA;EACE,YAAA;EAAa,eAAA;EAAgB,kBAAA;EAAmB,sBAAA;AAMlD","sourcesContent":["::ng-deep.cdk-overlay-pane{\r\n  max-width: 60% !important;\r\n    pointer-events: auto;\r\n    width: 100%;\r\n    position: static;\r\n    // margin: auto !important;\r\n    position: absolute !important;\r\n    margin-left: 0px;\r\n    margin-right: 0px;\r\n    right: 3% !important;\r\ntransform: none !important;\r\n}\r\n\r\n::ng-deep.mat-dialog-title{\r\n  margin: 0 !important;\r\n    padding: 1% !important;\r\n    background-color: #17a2b8 !important;\r\n    color: white !important;\r\n    padding-block: 0px !important;\r\n    font-size: 15px !important;\r\n}\r\n\r\n::ng-deep .mat-dialog-content{\r\n  overflow-x: hidden !important;\r\n  max-height: 440px !important;\r\n  // min-height: 250px !important;\r\n  padding-inline: 5% !important;\r\n  padding-block: 1% !important;\r\n}\r\n\r\n::ng-deep.mat-dialog-container{\r\n  transform: none !important;\r\n  padding: 0 !important;\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n::ng-deep .mat-dialog-actions {\r\n  border-top: 1px solid #cfb9b975 !important;\r\n  background-color: lightblue !important;\r\n  padding: 0 !important;\r\n  justify-content: end !important;\r\n  margin-bottom: 0 !important;\r\n  min-height: 41px;\r\n  overflow: hidden;\r\n}\r\n\r\n.close_btn{\r\n  margin-left: 48px;height: 29px;position: relative;top: -3px;\r\n}\r\n.update_btn{\r\n  position: relative;\r\n    top: -3px;\r\n    height: 29px;\r\n}\r\n\r\n// ::ng-deep.cdk-overlay-dark-backdrop {\r\n//   background:none!important;\r\n// }\r\n\r\n::ng-deep.mat-select-panel-wrap {\r\n  flex-basis: unset !important;\r\n}\r\n\r\n.save_btn_condition{\r\n    width: fit-content;\r\n    position: relative;\r\n    left: 91%;\r\n    margin-bottom: 1%;\r\n}\r\n\r\n\r\n.Version_dropDownss{\r\n  // width: 62%;\r\n  margin-left: 4%;\r\n  margin-bottom: 4%;\r\n  height: 32px;\r\n  // box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-bottom: 1%;\r\n  width: 80%;\r\n}\r\n::ng-deep.Version_dropDownss  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 30px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.Version_dropDownss .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Version_dropDownss .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n.mat_selection{\r\n  // width: 62%;\r\n  margin-left: 4%;\r\n  margin-bottom: 4%;\r\n  height: 35px;\r\n  // box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-bottom: 1%;\r\n}\r\n::ng-deep.mat_selection  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.mat-selection_label .mat-form-field-label-wrapper{\r\n  position: absolute !important;\r\n  top: 1px !important;\r\n}\r\n::ng-deep.mat-selection_label  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n\r\n.inputfield{\r\n  height: 28px;font-size: 12px;border-radius: 5px;border: 1px solid grey;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
